// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vote-confirmations-table .row:nth-child(even){background-color:#f2f7f7}", ""]);
// Exports
module.exports = exports;
